import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';

import { isSettingEnabled } from 'utils/common';
import { MANAGE_DELIVERY_LITE_DEFAULT_TEXT } from 'constants/verbiage';

const PREFIX = 'ManageDeliveryLiteLink';

const classes = {
  container: `${PREFIX}-container`,
  link: `${PREFIX}-link`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    backgroundColor: theme.colorTokens?.surfaceContainerLowest || '#f5f5f5',
    border: `1px solid ${theme.colorTokens?.outlineVariant || '#e0e0e0'}`,
    borderRadius: '8px',
    padding: '1rem 1.5rem',
    textAlign: 'center',
    marginBottom: '1.5rem',
  },

  [`& .${classes.link}`]: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: 500,
    fontSize: '16px',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const ManageDeliveryLiteLink = compose(
  inject('store'),
  observer,
)(({ store, trackingCode, isDelivered }) => {
  const { deliveryStore } = store;
  const { settings } = deliveryStore;

  const isEnabled = isSettingEnabled(settings?.enable_manage_delivery_lite);

  // With access-first active the Manage Delivery card carries the lite entry,
  // so the standalone link is redundant while that card is on the page
  const isAccessFirst = isEnabled && isSettingEnabled(settings?.enable_manage_delivery_access_first);

  if (!isEnabled || (isAccessFirst && !isDelivered)) {
    return null;
  }

  // Get configurable text or use default
  const linkText = settings?.manage_delivery_lite_text || MANAGE_DELIVERY_LITE_DEFAULT_TEXT;

  return (
    <StyledBox className={classes.container}>
      <Link to={`/${trackingCode}/access-code`} className={classes.link}>
        <Typography variant="body1">{linkText}</Typography>
      </Link>
    </StyledBox>
  );
});

export default ManageDeliveryLiteLink;
